/** Phrases that must never appear in D-Tools option overview / why-this-option fallback copy. */
export const DTOOLS_BANNED_OPTION_COPY_PHRASES = [
  "brings together the amplification and projection components",
  "selected to work together as one cohesive experience",
  "built around amplification, projection, video processing",
  "complete performance system",
  "Option 1 brings together",
] as const;

export function containsBannedOptionCopy(text: string): string | null {
  const lower = String(text ?? "").toLowerCase();
  for (const phrase of DTOOLS_BANNED_OPTION_COPY_PHRASES) {
    if (lower.includes(phrase.toLowerCase())) return phrase;
  }
  return null;
}

export function assertNotBannedOptionCopy(text: string): void {
  const hit = containsBannedOptionCopy(text);
  if (hit) {
    throw new Error(`Banned option copy phrase detected: "${hit}"`);
  }
}
